<template>
    <o-datepicker v-model="d" icon="calendar" :min-date="minDate" :max-date="maxDate" @input="UpdateModel" @activeChange="UpdateModel" v-if="!loading"></o-datepicker>
</template>
<script>
import { ref, inject, onMounted } from "vue";

export default {
    props: {
        modelValue: {
            type: [String, Object, Date],
            default: () => {
                return null;
            }
        },
        format: {
            type: String,
            default: null
        },
        utc: {
            type: Boolean,
            default: true
        }
    },
    emits: ["update:modelValue"],
    setup(props, context) {
        const moment = inject("$moment");

        const minDate = ref(moment("2008-01-01").toDate());
        const maxDate = ref(moment().toDate());

        const d = ref(null);
        const loading = ref(true);

        let _d = null;
        if (typeof props.modelValue === "string") {
            if (!props.format) {
                _d = moment.utc(props.modelValue);
            } else {
                _d = moment.utc(props.modelValue, props.format);
            }
        } else if (Object.prototype.toString.call(props.modelValue) === "[object Date]") {
            _d = moment.utc(props.modelValue);
        } else if (moment.isMoment(props.modelValue)) {
            _d = props.modelValue.utc();
        }

        if (_d && moment.isMoment(_d)) {
            d.value = _d.toDate();
        }

        const UpdateModel = () => {
            let val;
            if (props.utc) {
                val = moment(d.value).utc().toDate();
            } else {
                val = d.value;
            }
            context.emit("update:modelValue", val);
        };

        onMounted(() => {
            loading.value = false;
        });

        return {
            d,
            loading,
            minDate,
            maxDate,
            UpdateModel
        };
    }
};
</script>
